import React from 'react'

import 'swiper/scss'

const TestimonialCard = ({ slide, groupHasImages }) => {
  const { heading, background_color, background_image, description } = slide
  const patient_name = heading?.split('/')[0]
  const patient_category = heading?.split('/')[1]
  const stars = 5
  const background_gradient = 'linear-gradient(to bottom right, color-mix(in srgb, ' + background_color + ', white 60%) 50%, ' + background_color + ')'

  return (
    <swiper-slide>
      <div className='card-wrapper' style={{ backgroundColor: background_color, background: background_gradient}}>
        <div className='inner-card-wrapper'>
        {groupHasImages ? (
            <figure className='image-wrapper'>
            <img src={background_image?.url ?? ''} alt={background_image?.alt ?? ''} />
            </figure>
          ): null}
          <div className='stars' >
          {/* from Jordan: there might be a better way to do this, possibly even making a 5 star component to just import. */}
          {Array.from({ length: stars }, (_, i) => 
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
              <path d="M10.5189 1.0565C10.6775 0.725957 10.942 0.725957 11.1139 1.0565L13.8376 6.57C13.9962 6.90054 14.4325 7.20465 14.7895 7.25753L20.8716 8.14339C21.2286 8.19628 21.3211 8.4475 21.0567 8.69871L16.6538 12.9826C16.3894 13.2338 16.2307 13.7494 16.2836 14.1064L17.3281 20.162C17.3942 20.519 17.1695 20.6777 16.8521 20.5058L11.418 17.6499C11.0874 17.478 10.5586 17.478 10.2412 17.6499L4.80706 20.5058C4.47652 20.6777 4.26497 20.519 4.33108 20.162L5.3756 14.1064C5.44171 13.7494 5.26983 13.247 5.00539 12.9826L0.589304 8.69871C0.324868 8.4475 0.404199 8.19628 0.77441 8.14339L6.85644 7.25753C7.21343 7.20465 7.64975 6.88732 7.80841 6.57L10.5189 1.0565Z" fill="#FFBC00"/>
            </svg>)}
          </div>
          <div className='card-content'>
            <p className='card-description subhead-s5'>{description}</p>
            <div className='patient-info'>
              <p className='card-patient-name paragraph-bold'>{patient_name}</p>
              <p className='card-patient-category xsmall'>{patient_category}</p>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
  )
}

export default TestimonialCard
